import React from 'react'
import VideosDataTable from './components/VideosDataTable'

const VideosPlayback = () => {
    return (
        <div className="flex flex-col gap-4 mt-4">

            <div className="flex-1 tripTable">
                <VideosDataTable />
            </div>
        </div>)
}

export default VideosPlayback